import { render, staticRenderFns } from "./NotificationPatientApprovalRequest.vue?vue&type=template&id=4f7a64ca"
import script from "./NotificationPatientApprovalRequest.vue?vue&type=script&lang=js"
export * from "./NotificationPatientApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports